export const baseUrl =
  process.env.REACT_APP_DEVELOPMENT_MODE === "PRODUCTION"
    ? process.env.REACT_APP_URL
    : process.env.REACT_APP_TESTING_REACT_APP_URL;
